module.exports = __webpack_public_path__ + "img/illust-03.cb1ca60c.png";